import { useQuery } from "@tanstack/vue-query";
import { SuspensionStatus } from "mws-ts-v2-sdk";

import { queries } from "~/queries";

export const useUserIsSoftSuspended = () => {
  if (import.meta.server) return;

  const { isLoggedIn } = useAuth();
  const { data: userDetails } = useQuery({
    ...queries.me.details(),
    enabled: isLoggedIn,
  });

  return computed(() => {
    return Boolean(
      userDetails.value?.suspensionStatus === SuspensionStatus.SoftSuspended,
    );
  });
};

export const useRedirectSoftSuspendedUser = (options: {
  enabled: MaybeRefOrGetter<boolean>;
}) => {
  if (import.meta.server) return;

  const route = useRoute();
  const router = useRouter();
  const localePath = useLocalePath();

  const { setIsLayoutDisabled } = useLayout();
  const isSoftSuspended = useUserIsSoftSuspended();
  const allowedPaths = ["checkout/*", "my-account/my-orders*"];

  watchEffect(
    () => {
      if (!toValue(options.enabled)) return;

      const isAllowedPath = allowedPaths.some((path) => route.path.match(path));

      // If user is on one of the allowed paths,
      // check if we need to disable the layout based on the soft suspension status
      if (isAllowedPath) {
        return setIsLayoutDisabled(isSoftSuspended?.value ?? false);
      }

      // If the user is soft suspended and not already on one of the allowed paths,
      // redirect them to the my orders page
      if (isSoftSuspended?.value) {
        return router.replace(localePath("/my-account/my-orders"));
      }
    },
    {
      // Wait for the vue application to have rendered once before redirecting
      flush: "post",
    },
  );
};
